// extracted by mini-css-extract-plugin
export default {"form-control":"MainSearchForm_form-control__jqM8Y","form-control-button":"MainSearchForm_form-control-button__2WB9F"};